import Vue from 'vue';

// Domain
import {
  InvestmentGoalsStateManager,
} from '@/modules/flagship/catalogs/investment-goals/domain/state/investment-goals-state-manager';
import InvestmentGoalsState
  from '@/modules/flagship/catalogs/investment-goals/domain/state/investment-goals-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class InvestmentGoalsVueStateManager implements InvestmentGoalsStateManager {
  // eslint-disable-next-line max-len
  private _state: InvestmentGoalsState = Vue.observable<InvestmentGoalsState>(new InvestmentGoalsState());

  private readonly observers: Observer[] = [];

  get state(): InvestmentGoalsState {
    return this._state;
  }

  set state(value: InvestmentGoalsState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<InvestmentGoalsState>) {
    type Keys = keyof InvestmentGoalsState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
